import React from "react";
import { inject, observer } from "mobx-react";



const DonationList = (props) => {

    const { donations } = props.overlayStore;

    const addZeroes = (num) => {
        let value = num;
        const res = String(num).split(".");
        if (res.length === 1 || (res[1].length <= 3)) {
            value = value.toFixed(2).replace(/\.00$/, "");
        }
        return value
    }


    return (
        <div
            className="donor-list"
            ref="marqueeContainer"
        >
            <div className="fade-left"></div>
            <div className="fade-right"></div>
            <div
                className="marquee-wrap"
                id="marquee-wrap"
            >
                <div
                    className="scroller"
                    id="scoller"
                    ref="content"
                >
                    {donations.length ?
                        <ul
                            id="donors"
                            ref="listContainer"
                        >
                            <li className="recent-dono">Recent Donations</li>
                            {donations.slice().reverse().map(donation => (
                                <li key={donation.id}>
                                    <strong>{donation.name}</strong>{" "}
                                    <span className="donation-amount">${addZeroes(donation.amount)}</span>{" "}
                                </li>
                            ))}
                        </ul>
                        :
                        ""
                    }
                </div>

            </div>
        </div>
    );
}

export default inject("overlayStore")(observer(DonationList));